module.exports = __webpack_public_path__ + "fc29fd33034941cd9dc3a4aa148925f2.svg";